import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { JobsRepository } from '../../repositories';
import { Observable } from 'rxjs';
import { JobTemplate } from "../../domain";


@Injectable({ providedIn: 'root' })
export class GetJobTemplateUsecase implements UseCase< undefined, JobTemplate[]> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(): Observable<JobTemplate[]> {
    return this.jobRepository.getJobTemplateLookUp();
  }

}
